/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { ProposalsContext, useProposalsContext } from './proposals-context'
import type * as Fetcher from './proposals-fetcher'
import { proposalsFetch } from './proposals-fetcher'
import type * as Responses from './proposals-responses'
import type * as Schemas from './proposals-schemas'

export type ProposalsCategoriesListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
}

export type ProposalsCategoriesListHeaders = {
  ['X-Locale']?: string
}

export type ProposalsCategoriesListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ProposalsCategoriesListVariables = {
  headers?: ProposalsCategoriesListHeaders
  queryParams?: ProposalsCategoriesListQueryParams
} & ProposalsContext['fetcherOptions']

/**
 * Returns the list of Proposals Categories
 */
export const fetchProposalsCategoriesList = (variables: ProposalsCategoriesListVariables, signal?: AbortSignal) =>
  proposalsFetch<
    Schemas.ProposalsCategories,
    ProposalsCategoriesListError,
    undefined,
    ProposalsCategoriesListHeaders,
    ProposalsCategoriesListQueryParams,
    {}
  >({ url: '/proposals/categories', method: 'get', ...variables, signal })

/**
 * Returns the list of Proposals Categories
 */
export const useProposalsCategoriesList = <TData = Schemas.ProposalsCategories>(
  variables: ProposalsCategoriesListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProposalsCategories, ProposalsCategoriesListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useProposalsContext(options)
  return reactQuery.useQuery<Schemas.ProposalsCategories, ProposalsCategoriesListError, TData>({
    queryKey: queryKeyFn({
      path: '/proposals/categories',
      operationId: 'proposalsCategoriesList',
      variables,
    }),
    queryFn: ({ signal }) => fetchProposalsCategoriesList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ProposalsRequestGetQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
}

export type ProposalsRequestGetHeaders = {
  ['X-Locale']?: string
}

export type ProposalsRequestGetError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ProposalsRequestGetVariables = {
  headers?: ProposalsRequestGetHeaders
  queryParams?: ProposalsRequestGetQueryParams
} & ProposalsContext['fetcherOptions']

/**
 * Returns the details of Proposals
 */
export const fetchProposalsRequestGet = (variables: ProposalsRequestGetVariables, signal?: AbortSignal) =>
  proposalsFetch<
    Schemas.ProposalsPaginated,
    ProposalsRequestGetError,
    undefined,
    ProposalsRequestGetHeaders,
    ProposalsRequestGetQueryParams,
    {}
  >({ url: '/proposals', method: 'get', ...variables, signal })

/**
 * Returns the details of Proposals
 */
export const useProposalsRequestGet = <TData = Schemas.ProposalsPaginated>(
  variables: ProposalsRequestGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProposalsPaginated, ProposalsRequestGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useProposalsContext(options)
  return reactQuery.useQuery<Schemas.ProposalsPaginated, ProposalsRequestGetError, TData>({
    queryKey: queryKeyFn({
      path: '/proposals',
      operationId: 'proposalsRequestGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchProposalsRequestGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DocumentListQueryParams = {
  /**
   * @default 0
   */
  pagingOffset?: number
  /**
   * @default 20
   */
  pagingLimit?: number
  name?: string
  /**
   * Document associated to entity
   */
  entityId?: string
  type?: Schemas.DocumentType[]
}

export type DocumentListError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentListVariables = {
  queryParams?: DocumentListQueryParams
} & ProposalsContext['fetcherOptions']

/**
 * Returns all the documents
 */
export const fetchDocumentList = (variables: DocumentListVariables, signal?: AbortSignal) =>
  proposalsFetch<Schemas.DocumentPaginated, DocumentListError, undefined, {}, DocumentListQueryParams, {}>({
    url: '/proposals/documents',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns all the documents
 */
export const useDocumentList = <TData = Schemas.DocumentPaginated>(
  variables: DocumentListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DocumentPaginated, DocumentListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useProposalsContext(options)
  return reactQuery.useQuery<Schemas.DocumentPaginated, DocumentListError, TData>({
    queryKey: queryKeyFn({
      path: '/proposals/documents',
      operationId: 'documentList',
      variables,
    }),
    queryFn: ({ signal }) => fetchDocumentList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type DocumentCreateError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type DocumentCreateVariables = {
  body: Schemas.DocumentCreateRequest
} & ProposalsContext['fetcherOptions']

/**
 * Create Document Request
 */
export const fetchDocumentCreate = (variables: DocumentCreateVariables, signal?: AbortSignal) =>
  proposalsFetch<Schemas.CreateResponse, DocumentCreateError, Schemas.DocumentCreateRequest, {}, {}, {}>({
    url: '/proposals/documents',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Create Document Request
 */
export const useDocumentCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.CreateResponse, DocumentCreateError, DocumentCreateVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useProposalsContext()
  return reactQuery.useMutation<Schemas.CreateResponse, DocumentCreateError, DocumentCreateVariables>({
    mutationFn: (variables: DocumentCreateVariables) => fetchDocumentCreate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type DocumentsDeleteQueryParams = {
  /**
   * The ids of the documents to delete, semicolon separated.
   */
  ids: string[]
}

export type DocumentsDeleteError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Responses.ErrorBadRequest
}>

export type DocumentsDeleteVariables = {
  queryParams: DocumentsDeleteQueryParams
} & ProposalsContext['fetcherOptions']

/**
 * Deletes the documents specified by the ids. It is possible to delete only the documents not already locked. The ids are semicolon separated. The maximum number of ids is 100.
 */
export const fetchDocumentsDelete = (variables: DocumentsDeleteVariables, signal?: AbortSignal) =>
  proposalsFetch<undefined, DocumentsDeleteError, undefined, {}, DocumentsDeleteQueryParams, {}>({
    url: '/proposals/documents',
    method: 'delete',
    ...variables,
    signal,
  })

/**
 * Deletes the documents specified by the ids. It is possible to delete only the documents not already locked. The ids are semicolon separated. The maximum number of ids is 100.
 */
export const useDocumentsDelete = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, DocumentsDeleteError, DocumentsDeleteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useProposalsContext()
  return reactQuery.useMutation<undefined, DocumentsDeleteError, DocumentsDeleteVariables>({
    mutationFn: (variables: DocumentsDeleteVariables) => fetchDocumentsDelete({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type QueryOperation =
  | {
      path: '/proposals/categories'
      operationId: 'proposalsCategoriesList'
      variables: ProposalsCategoriesListVariables
    }
  | {
      path: '/proposals'
      operationId: 'proposalsRequestGet'
      variables: ProposalsRequestGetVariables
    }
  | {
      path: '/proposals/documents'
      operationId: 'documentList'
      variables: DocumentListVariables
    }
